<template>
	<div class="card bd-0">
		<div class="table-responsive">
			<table class="table table-dashboard mg-b-0">
				<thead>
					<tr v-if="portfolioType === 2">
						<th scope="col">Security</th>
						<th scope="col">Asset Type</th>
						<th scope="col" class="text-right">Value</th>
					</tr>
					<tr v-else>
						<th scope="col">Security</th>
						<th scope="col">Asset Type</th>
						<th scope="col" class="text-right">Units</th>
						<th scope="col" class="text-right">Price</th>
						<th scope="col" class="text-right">Value</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td colspan="5"><spinner-component :loading="loading" /></td>
					</tr>
					<tr v-if="error" class="tx-center tx-danger">
						<td colspan="5">{{ error }}</td>
					</tr>

					<tr v-else v-for="holding in holdings" :key="holding.id">
						<td class="tx-color-03 tx-normal" v-tooltip:top="holding.security_details.description">{{ holding.security_details.name }}</td>
						<td class="tx-color-03 tx-normal">{{ holding.security_details.type_details.name }}</td>
						<td class="tx-medium text-right" v-if="portfolioType !== 2">{{ holding.units | toNumber('0,0.0000') }}</td>
						<td class="tx-medium text-right" v-if="portfolioType !== 2">{{ getHoldingPrice(holding) | toNumber('0,0.0000') }}</td>
						<td class="tx-medium text-right">
							{{ calculateHoldingValue(holding) | toNumber }}
						</td>
					</tr>
					<tr>
						<td v-if="holdings" class="tx-medium text-right" colspan="5">
							<span class="tx-bold">{{ calculateHoldingsTotal() }}</span>
						</td>
						<td v-else class="tx-medium text-center" :class="[loading ? 'bd-t-0' : '']" colspan="5">
							<span v-show="!loading">No Data Available</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			holdings: null,
			error: null,
		};
	},
	created() {
		this.fetchHoldings();
	},
	methods: {
		fetchHoldings() {
			this.error = this.holdings = null;
			this.loading = true;

			axios
				.get(`/api/portfolio/${this.$route.params.portfolio}/holdings`)
				.then((response) => {
					const holdings = response.data.data.holdings;

					if (!this.isEmpty(holdings)) {
						this.holdings = holdings;
					}
				})
				.catch((error) => {
					this.error = error.toString();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		calculateHoldingValue({ units, security_details }) {
			const price = security_details?.price?.value;
			return (units * price).toFixed(2);
		},
		calculateHoldingsTotal() {
			if (this.holdings) {
				const holdingsTotal = this.holdings.reduce((previous, next) => {
					const price = next.security_details?.price?.value;

					return parseFloat(previous) + parseFloat(next.units) * price;
				}, 0);

				return this.$options.filters.toCurrency(holdingsTotal, this.holdings.currency);
			}
		},
		getHoldingPrice({ security_details }) {
			return security_details?.price?.value;
		},
	},
	props: ['portfolioId', 'portfolioType'],
};
</script>
